import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";

// Connects to data-controller="flatpickr"
export default class extends Controller {
  static values = {
    url: String,
    defaultDate: String,
    minDate: String,
    maxDate: String,
    enableTime: Boolean,
    noCalendar: Boolean,
    dateFormat: String
  };

  connect() {
    const isWrapper = this.element.tagName !== 'INPUT';

    const formatInput = (selectedDates, _dateStr, instance) => {
      if (!isWrapper && selectedDates.length > 0) {
        if (this.noCalendarValue) {
          instance.input.value = instance.formatDate(selectedDates[0], "H:i");
        } else if (this.enableTimeValue) {
          instance.input.value = instance.formatDate(selectedDates[0], "d/m/Y H:i");
        } else {
          instance.input.value = instance.formatDate(selectedDates[0], "d/m/Y");
        }
      }
    };

    const dropdown = document.querySelector("#dropdownFilter");

    this.fp = flatpickr(this.element, {
      wrap: isWrapper,
      enableTime: this.enableTimeValue || false,
      noCalendar: this.noCalendarValue || false,
      dateFormat: this.dateFormatValue || (this.noCalendarValue ? "H:i" : "Y-m-d"),
      altInput: isWrapper,
      altFormat: this.noCalendarValue ? "H:i" : (this.enableTimeValue ? "d/m/Y H:i" : "d/m/Y"),
      defaultDate: this.defaultDateValue,
      minDate: this.minDateValue,
      maxDate: this.maxDateValue,
      appendTo: dropdown || undefined,

      onChange: (selectedDates, dateStr) => {
        if (this.hasUrlValue && selectedDates.length > 0) {
          const urlDate = dateStr.replaceAll('-', '');
          window.location.href = `${this.urlValue}?date=${urlDate}`;
        }
      },

      onReady: formatInput,
      onClose: formatInput,
    });
  }

  disconnect() {
    if (this.fp) {
      this.fp.destroy();
    }
  }
}
